import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import { integrationTemplates } from './integration-templates.js'

export function readIntegrationTemplate(
  integrationId: BetterstartIntegrationId,
  relativePath: string
): string {
  return integrationTemplates.read(integrationId, relativePath)
}
